import "./App.css";

function Tag() {
  return (
    <>
      <div className="tagsContanir">
        <a href="#" className="atag">
          About us
        </a>
        <a href="#" className="atag">
          Initiatives
        </a>
        <a href="#" className="atag">
          Blog
        </a>
        <a href="#" className="atag">
          Contact us
        </a>
      </div>
    </>
  );
}

export default Tag;